import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    header: 'mb-6',
    title: 'text-[32px] leading-[120%] font-semibold',
    subtitle: 'mb-4 text-sm text-gray-500',
    suggestions: 'mt-[24px] flex flex-col gap-[4px] bg-white p-0',
    suggestion:
      'hover:text-brand-300 cursor-pointer px-[16px] py-[12px] text-base leading-[140%] font-light transition-colors',
    inputClear:
      'flex size-6 cursor-pointer place-items-center items-center justify-center rounded-full bg-gray-100',
    inputClearIcon: 'text-icon-secondary',
    loading: 'loading h-6 w-6',
    loadingContainer:
      'absolute top-0 left-0 flex h-full w-full items-center justify-center bg-white/50'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
